import { render, staticRenderFns } from "./CompleteProfileDialog.vue?vue&type=template&id=0982d20b&scoped=true"
import script from "./CompleteProfileDialog.vue?vue&type=script&lang=js"
export * from "./CompleteProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./CompleteProfileDialog.vue?vue&type=style&index=0&id=0982d20b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982d20b",
  null
  
)

export default component.exports